'use client';
import AmimationFadeLazy from '../animation-fade-lazy/animation-fade-lazy';
import { LazyMotion, m as motion } from 'framer-motion';
import LinkWrapper from '../link-wrapper/link-wrapper';
import { InternalPageLinkFragmentFragment } from '@fm-nx/contentful-types';
import slugify from '@sindresorhus/slugify';
import loadFeatures from '../__constants__/framer-features';
import classNames from 'classnames';

type NumberedBlocksProps = {
    blocks?: Array<{
        header?: string | null;
        fact?: string | null;
        link?: InternalPageLinkFragmentFragment | null;
    } | null> | null;
    mode?: 'dark' | 'light';
};

const item = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
};

export const NumberedBlocks = (props: NumberedBlocksProps) => {
    const { blocks, mode = 'light' } = props;

    if (!blocks) return null;

    const textColor = mode === 'dark' ? 'text-white' : 'text-gray-900';

    return (
        <div className="relative">
            <div className="my-4 md:mt-20 md:mb-40">
                <AmimationFadeLazy>
                    <div className="w-full mx-auto max-w-container">
                        <div className="mx-6 md:mx-0 md:grid md:grid-cols-14">
                            <div className="md:col-span-12 md:col-start-2">
                                <div className="grid grid-cols-1 gap-0 md:grid-cols-3 md:gap-8">
                                    {blocks?.map((block, index) => {
                                        if (!block) return null;
                                        return (
                                            <LazyMotion
                                                features={loadFeatures}
                                                key={`${index}-${slugify(block.header || '')}`}
                                            >
                                                <motion.div
                                                    variants={item}
                                                    className={`pt-0 mb-8 col-span-1 space-y-6`}
                                                >
                                                    {block.header && (
                                                        <h4 className={`h-md ${textColor}`}>
                                                            <span className="text-gray-500">
                                                                {String(index + 1).padStart(2, '0')}
                                                            </span>{' '}
                                                            {block.header}
                                                        </h4>
                                                    )}
                                                    <p className={`font-light p-xl ${textColor}`}>{block.fact}</p>
                                                    {block.link && (
                                                        <LinkWrapper
                                                            page={block.link.linkPage ? block.link.linkPage : undefined}
                                                            href={block.link.linkText ? block.link.linkText : undefined}
                                                            className={classNames(`inline-block mt-4 h5 emdash-push`, {
                                                                'text-white emdash-push--dark': mode === 'dark',
                                                            })}
                                                        >
                                                            {block.link.linkText}
                                                        </LinkWrapper>
                                                    )}
                                                </motion.div>
                                            </LazyMotion>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </AmimationFadeLazy>
            </div>
        </div>
    );
};

export default NumberedBlocks;
